import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SiteDashboard from "./siteDashboard";
import { exportSitesCsv, getSiteDashboardListing } from "services/redux/sales/siteDashboard/action";
import { getListFilterData } from "services/redux/sales/financeContract/action";

const mapStateToProps = (state) => ({
  sitesList: state.siteDashboardReducer.sitesList,
  isExportingCsv: state.siteDashboardReducer.exportCsv?.isExporting,
  filterDropdownList: state.preSalesListReducer.filterDropdownList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getListFilterData,
      getSiteDashboardListing,
      exportSitesCsv,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SiteDashboard);
